import loadable from "@loadable/component";

export const AccountListPage = loadable(() => import("./account/list"), {
  resolveComponent: ({ AccountListPage }) => AccountListPage,
});

export const RoleListPage = loadable(() => import("./role/list"), {
  resolveComponent: ({ RoleListPage }) => RoleListPage,
});

export const MenuListPage = loadable(() => import("./menu/list"), {
  resolveComponent: ({ MenuListPage }) => MenuListPage,
});
